<template>
  <div>
    <UserContact></UserContact>
  </div>
</template>

<script>
import UserContact from "@/components/user/UserContact.vue";

export default {
  name: "UserContactView",
  components: {
    UserContact
  }
};
</script>

<style></style>
